import { Alert, Box, Container, Snackbar, SnackbarCloseReason, Typography } from "@mui/material";
import React, { useEffect } from "react";
import { useLocation } from 'react-router-dom';

const ErrorPage: React.FC = () => {

  const imagePath = "/assets/images/warning.png";

  const [open, setOpen] = React.useState(false);

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const errorMessage = queryParams.get('message');

  useEffect(() => {
    showToast();
  }, [])
  

  const showToast = () => {
    setOpen(true);
  };

  const handleClose = (
    event?: React.SyntheticEvent | Event,
    reason?: SnackbarCloseReason,
  ) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpen(false);
  };

  return (
    <Container sx={{
      height: "100%",
      width: "100%",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    }}>
      <Snackbar open={open} autoHideDuration={6000} onClose={handleClose} anchorOrigin={{ vertical: "top", horizontal: "center" }}>
        <Alert
          onClose={handleClose}
          severity="error"
          variant="filled"
          sx={{ width: '100%' }}
        >
          {errorMessage}
        </Alert>
      </Snackbar>

      <Box>
        <Box textAlign={"center"}>
          <img src={imagePath} alt="Dynamic Icon" width={200} height={200} />
        </Box>
        <Box textAlign={"center"}>
          <Typography mt={5} variant="h4">Something went wrong!!!</Typography>
        </Box>
      </Box>
    </Container>
  );
};

export default ErrorPage;
